import dayjs from 'dayjs';
import { getShareUid } from './share';
import { getUd } from './device';
export var setExpireStorage = function setExpireStorage(key, value, expire) {
  var obj = {
    data: value,
    time: Date.now(),
    expire: expire
  };
  localStorage.setItem(key, JSON.stringify(obj));
};
export var getExpireStorage = function getExpireStorage(key) {
  var val = localStorage.getItem(key);

  if (!val) {
    return val;
  }

  var obj = JSON.parse(val);

  if (Date.now() - obj.time > obj.expire) {
    localStorage.removeItem(key);
    return null;
  }

  return obj.data;
};
export var category = 'creator'; // 频控，N天一次

export var getDayExpireStorage = function getDayExpireStorage(key) {
  var dayNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // 此时频控强制无效，表示没用过
  if (force) {
    localStorage.setItem("".concat(category, "_").concat(key), "".concat(new Date().getTime()));
    return true;
  }

  var storageTime = localStorage.getItem("".concat(category, "_").concat(key));

  if (!storageTime) {
    localStorage.setItem("".concat(category, "_").concat(key), "".concat(new Date().getTime())); // 说明今天没有

    return true;
  } // 说明今天已经用过了


  var nowTime = dayjs(); // 比如今天用过，存了今天11月2号，dayNumber =2 ，2天1次，那么就是让 11月3号之前都不弹--> 11月3号>此刻都不弹

  var deadDay = dayjs(Number(storageTime)).add(dayNumber - 1, 'day');
  var alreadyUse = deadDay.isAfter(nowTime, 'day') || deadDay.isSame(nowTime, 'day');

  if (alreadyUse) {
    return false;
  }

  localStorage.setItem("".concat(category, "_").concat(key), "".concat(new Date().getTime()));
  return true;
};

var getRealStorageName = function getRealStorageName(prefix, name) {
  var dimension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'user';
  var userId = getShareUid();
  return dimension === 'user' ? "creator_".concat(prefix, "_").concat(name, "_").concat(userId) : "creator_".concat(prefix, "_").concat(name);
}; // 以数组形式存储


export var setArrStorage = function setArrStorage(prefix, name, value) {
  var dimension = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'user';
  var realStorageName = getRealStorageName(prefix, name, dimension);
  var storage = localStorage.getItem(realStorageName);

  if (storage) {
    var valueArr = storage.split(',');

    if (valueArr.includes(value)) {
      return;
    }

    if (value) {
      valueArr.push(value);
    }

    localStorage.setItem(realStorageName, valueArr.join(','));
  } else {
    localStorage.setItem(realStorageName, value);
  }
}; // 以数组形式存储,删除当前value相关的内容

export var deleteArrStorage = function deleteArrStorage(prefix, name, value) {
  var dimension = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'user';
  var realStorageName = getRealStorageName(prefix, name, dimension);
  var storage = localStorage.getItem(realStorageName);

  if (storage) {
    var valueArr = storage.split(',');

    if (valueArr.includes(value)) {
      valueArr = valueArr.filter(function (item) {
        return item !== value;
      });
    }

    if (valueArr.length === 0) {
      localStorage.removeItem(realStorageName);
    } else {
      localStorage.setItem(realStorageName, valueArr.join(','));
    }
  }
}; // 以数组形式存储,判断是否存储了

export var getInArrStorage = function getInArrStorage(prefix, name, value) {
  var dimension = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'user';
  var realStorageName = getRealStorageName(prefix, name, dimension);
  var storage = localStorage.getItem(realStorageName);

  if (storage) {
    var valueArr = storage.split(',');

    if (valueArr.includes(value)) {
      return true;
    }

    return false;
  }

  return false;
}; // dimension = 'user' 是指以uid维度

var getCreatorStorageKey = function getCreatorStorageKey(key) {
  var dimension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'user';
  var name = key;

  if (typeof key !== 'string') {
    name = JSON.stringify(key);
  }

  var storageName = "".concat(category, "_").concat(name);

  if (dimension === 'user') {
    storageName += "_".concat(getUd());
  }

  return storageName;
};

export var creatorStorage = {
  get: function get(key) {
    var dimension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'user';

    if (!key) {
      return null;
    }

    var name = getCreatorStorageKey(key, dimension);
    var data = window.localStorage.getItem(name);

    if (data === null) {
      return null;
    }

    return JSON.parse(data);
  },
  set: function set(key, value) {
    var dimension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'user';

    if (!key || !value) {
      return null;
    }

    var name = getCreatorStorageKey(key, dimension);
    window.localStorage.setItem(name, JSON.stringify(value));
  },
  deleteKey: function deleteKey(key) {
    var dimension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'user';

    if (!key) {
      return;
    }

    var name = getCreatorStorageKey(key, dimension);
    window.localStorage.removeItem(name);
  },
  clear: function clear() {
    window.localStorage.clear();
  }
};